module.exports = __webpack_public_path__ + "img/pmonth2.ff540d9f.png";